var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C5.14913 0 0 5.17565 0 11.5592C0 17.3543 4.24733 22.1398 9.78075 22.9759V14.6224H6.93546V11.5843H9.78075V9.56238C9.78075 6.21502 11.4032 4.74603 14.1709 4.74603C15.4963 4.74603 16.1977 4.84525 16.5293 4.88956V7.54144H14.6414C13.4665 7.54144 13.0563 8.66172 13.0563 9.92361V11.5843H16.4996L16.0329 14.6224H13.0563V23C18.6693 22.2352 23 17.4111 23 11.5592C23 5.17565 17.8509 0 11.5 0Z",
    fill: "#4795DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.aaddd7edbf020527c772acf92a753118.svg";
export { ForwardRef as ReactComponent };